export default new class AgeConfirm {
  constructor() {
    this.ageOpenBtnSelector = 'age-dialog-button';
    this.ageCloseBtnSelector = 'age-dialog-close';
    this.ageOutlineButtonBtnSelector = 'outline-button';
    this.ageWrapperSelector = 'age-dialog';
    this.ageOpenWrapperSelector = 'age-dialog-open';

    this.sKey = 'age_dialog';

    this.show();
    this.handler();
  }

  show() {
    let bShow = localStorage.getItem(this.sKey);
    if (bShow === '1') {
      bShow = true;
    } else {
      bShow = false;
    }
    if (!bShow) {
      const self = this;
      $(document).ready(function () {
        $(`.${self.ageOpenBtnSelector}`).click();
      });
    }
  }

  handler() {
    $(document).on('click', `.${this.ageOpenBtnSelector}`, () => {
      const wrapper = $(`.${this.ageWrapperSelector}`);
      const body = $('body');
      wrapper.addClass(this.ageOpenWrapperSelector);
      body.toggleClass('no-y-scroll');
    });
    $(document).on('click', `.${this.ageCloseBtnSelector}`, () => {
      const wrapper = $(`.${this.ageWrapperSelector}`);
      const body = $('body');
      wrapper.removeClass(this.ageOpenWrapperSelector);
      body.toggleClass('no-y-scroll');
      localStorage.setItem(this.sKey, 1);
    });
    $(document).on('click', `.${this.ageOutlineButtonBtnSelector}`, () => {
      localStorage.setItem(this.sKey, null);
      location.reload();
    });
  }
}();
